import { sharedHeaders } from "../utils/constants"

const getDurations = {
  "type": "endpoint",
  "method": "get",
  "title": "Get Durations",
  "path": "/v1/durations",
  "description": "Get list of durations available for insurance purchases",
  "request": {
    "headers": [
      ...sharedHeaders
    ]
  },
  "responses": {
    "200": {
      "description": "Successful response",
      "content": {
        "application/json": {
          "schema": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/DurationDto"
            }
          }
        }
      }
    },
    "400": {
      "description": "Bad Request"
    },
    "401": {
      "description": "Unauthorized"
    },
    "500": {
      "description": "Internal Server Error"
    }
  },
  "components": {
    "schemas": {
      "DurationDto": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "description": "Duration ID",
            "example": "rkGTHb9cr39fx4NUFAYi"
          },
          "title": {
            "type": "string",
            "description": "Localized duration title",
            "example": "Day(s)"
          },
          "dates_required": {
            "type": "boolean",
            "description": "Indicates if dates are required for products using this duration",
            "example": true
          }
        },
        "required": [
          "id",
          "title",
          "dates_required"
        ]
      }
    }
  }
}

export { getDurations }
